module.exports = __webpack_public_path__ + "media/Video 150.ad64d2e1.mp4";